var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlockicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.29289 10.7071C7.48043 10.8946 7.73478 11 8 11C8.8 11 9 9.66667 9 9V7C9 6.20435 9.31607 5.44129 9.87868 4.87868C10.4413 4.31607 11.2044 4 12 4C12.7956 4 13.5587 4.31607 14.1213 4.87868C14.5857 5.34305 14.8821 5.94398 14.9715 6.58708C15.008 6.84977 15.1054 7.10536 15.2929 7.29289C15.6834 7.68342 16.3166 7.68342 16.7071 7.29289C16.8946 7.10536 17.0048 6.85053 16.9829 6.58622C16.8854 5.41167 16.3752 4.30412 15.5355 3.46447C14.5979 2.52678 13.3261 2 12 2C10.6739 2 9.40215 2.52678 8.46447 3.46447C7.52678 4.40215 7 5.67392 7 7V10C7 10.2652 7.10536 10.5196 7.29289 10.7071Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9H7C5.34315 9 4 10.3431 4 12V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V12C20 10.3431 18.6569 9 17 9Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.8C14 16.3464 13.1046 17.6 12 17.6C10.8954 17.6 10 16.3464 10 14.8C10 13.2536 10.8954 13 12 13C13.1046 13 14 13.2536 14 14.8Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17.6C13 18.3732 12.5523 19 12 19C11.4477 19 11 18.3732 11 17.6C11 16.8268 11.4477 16.2 12 16.2C12.5523 16.2 13 16.8268 13 17.6Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockicon);
export default __webpack_public_path__ + "static/media/unlock.icon.a4e9b59ca54df570cf68c6790040bbb9.svg";
export { ForwardRef as ReactComponent };